/**
 * Rótulo de cada produto que dispara automações e alertas — GEN-4080.
 *
 * São os MESMOS rótulos dos chips de produto da lib (`@taxlybr/kanban2-web`): a trilha de Automações e a
 * linha de origem do sino ("Certidões · via Alerta “CADIN”") falam do mesmo produto com o mesmo nome que
 * a lista de automações. Dois nomes para a mesma coisa é como se perde a confiança na navegação.
 *
 * `status` é o módulo guarda-chuva da situação (Conta Corrente, dívida ativa, CNPJ, IE); quando o
 * assunto é conhecido, ele é mais específico e vence.
 */
export const ROTULO_DO_PRODUTO: Record<string, string> = {
  certificate: "Certidões",
  dte: "Caixa Postal",
  tax_current_account: "Conta Corrente",
  divida_ativa: "Dívida ativa",
  cnpj_situation: "Situação do CNPJ",
  ie_situation: "Inscrição estadual",
  kanban2: "Kanban",
  registry: "Base Cadastral",
  status: "Situação",
};

/** Rótulo do produto, ou `undefined` para chave desconhecida — nunca o slug cru na tela. */
export const rotuloDoProduto = (chave: string | null | undefined): string | undefined =>
  chave ? ROTULO_DO_PRODUTO[chave] : undefined;
